<template>
    <div>
        <h4 class="font-weight-light">  Experiencia Laboral</h4>
        <ul class="list-unstyled" v-if="user">
            <li v-for="(item, key) in user.experience" :key="key">
                {{item.puesto}}
                <ol>{{item.empresa}}</ol>
                <ol>Area {{item.area}}</ol>
                <ol>{{item.descripcion}}</ol>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    props:{
        user :Object,
        isGold: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {

        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/student_profile/elements/Experience.vue